import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export interface CloudflarePagesProject {
  project: string
  ok: boolean
  error?: string
  latestDeployment?: {
    id: string
    status: string
    stage: string
    environment: string
    url: string
    createdAt: string
  }
}

export interface CloudflareWorkerScript {
  script: string
  ok: boolean
  error?: string
  requests24h?: number
  errors24h?: number
  cpuTimeP50?: number
  cpuTimeP99?: number
}

export interface CloudflareWafTopRule {
  ruleId: string
  source: string
  action: string
  count: number
}

export interface CloudflareStatusPayload {
  fetchedAt: string
  cached: boolean
  pages: { ok: boolean; error?: string; projects: CloudflarePagesProject[] }
  workers: { ok: boolean; error?: string; scripts: CloudflareWorkerScript[] }
  waf: { ok: boolean; error?: string; totalEvents24h?: number; topRules?: CloudflareWafTopRule[] }
}

export function useCloudflareStatus() {
  return useQuery<CloudflareStatusPayload>({
    queryKey: ['cloudflare-status'],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('cloudflare-status')
      if (error) throw error
      return data as CloudflareStatusPayload
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
